import { API_BASE_URL, ACCESS_TOKEN } from "../constants";
import { apiGet } from "../utils";

const request = (options) => {
  const headers = new Headers({
    "Content-Type": "application/json",
  });

  if (localStorage.getItem(ACCESS_TOKEN)) {
    headers.append(
      "Authorization",
      "Bearer " + localStorage.getItem(ACCESS_TOKEN)
    );
  }

  const defaults = { headers: headers };
  options = Object.assign({}, defaults, options);

  return fetch(options.url, options).then((response) =>
    response.json().then((json) => {
      if (!response.ok) {
        return Promise.reject(json);
      }
      return json;
    })
  );
};

export function getCurrentUser() {
  if (!localStorage.getItem("auth")) {
    return Promise.reject("No access token set.");
  }

  // return request({
  //   url: API_BASE_URL + "/api/profileDetails",
  //   method: "GET",
  // });

  return apiGet("/api/profileDetails");

  // return request({
  //   url: API_BASE_URL + "/api/v1/profile",
  //   method: "GET"
  // });
}
